<div *ngIf="config$ | async as app" class="action">
    <div
        class="circle"
        [ngClass]="{ highlighted: isMenuOpen }"
        [matMenuTriggerFor]="menu"
        (menuOpened)="toggleMenuOpen()"
        (menuClosed)="toggleMenuOpen()"
    >
        {{ app.user.firstName.charAt(0) | sentenceCase }}{{ app.user.lastName.charAt(0) | sentenceCase }}
    </div>

    <mat-menu #menu="matMenu" class="menu popup_top_index">
        <div class="line">
            <p class="name" [showOnlyWhenEllipsis]="true" [matTooltip]="getUserName(app.user.firstName, app.user.lastName)">
                {{ getUserName(app.user.firstName, app.user.lastName) }}
            </p>
            <p class="company" [showOnlyWhenEllipsis]="true" [matTooltip]="app.companyName">{{ app.companyName }}</p>
        </div>
        <div class="items">
            <a class="item-text" (click)="user()">{{ 'Layouts.Masthead.USER_PROFILE' | translate }}</a>
            <a class="item-text" *ngIf="displaySwitchCompany" (click)="switchAccount()">{{
                'Layouts.Masthead.SWITCH_ACCOUNT' | translate
            }}</a>
            <a class="item-text" (click)="logout()">{{ 'Layouts.Masthead.LOGOUT' | translate }}</a>
        </div>
    </mat-menu>
</div>
